import {connect} from 'react-redux';
import {SkipSection as Component} from './SkipSection';
import {createSelector} from 'reselect';
import {setNoteBookSection} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    nextSection: getNextSection(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toNextSection: (section) => {
      dispatch(setNoteBookSection(section));
    },
  };
}

export const SkipSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

// Reselect Methods
const getAllSections = ({notebook}) => notebook.sections;

const getNextSection = createSelector([getAllSections], (allSections) => {
  const currentSection = allSections.find(
    (section) => section.current === true
  );
  const nextSection = allSections.find(
    (section) => section.number === currentSection.number + 1
  );
  return nextSection;
});
